import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'

const available = (record) => hasAvailableAction(record, 'release_cwas')

const apiEndPoint = ({ type, type_id }) =>
  process.env.REACT_APP_API_HOST + `/api/${type}s/${type_id}/release-cwas`

// eslint-disable-next-line react/display-name
const form = ({ name }) => () => (
  <fieldset>Will allow parents to agree or reject CWA aggreements with {name}</fieldset>
)

const releaseCWAS = ({ record }) =>
  available(record)
    ? {
      label: 'Release CWAs',
      value: 'release_cwas',
      component: form(record),
      url: apiEndPoint(record),
    }
    : null

export default releaseCWAS



// WEBPACK FOOTER //
// ./src/gov-registrations/details/gov-actions/release-cwas.js